import { parseDigits } from '@/utils/formatters';

/**
 * Validates if a CEP is in the correct format (8 digits)
 * @param cep - CEP to be validated (may contain formatting)
 * @returns true if valid, false otherwise
 */
export const isValidCEP = (cep: string): boolean => {
  const cleanCep = parseDigits(cep);
  return cleanCep.length === 8 && !/^(\d)\1{7}$/.test(cleanCep);
};

/**
 * Validates if a Brazilian state is in the correct format (2 uppercase letters)
 * @param state - State to be validated
 * @returns true if valid, false otherwise
 */
export const isValidState = (state: string): boolean => {
  const cleanState = state.trim().toUpperCase();
  const validStates = [
    'AC',
    'AL',
    'AP',
    'AM',
    'BA',
    'CE',
    'DF',
    'ES',
    'GO',
    'MA',
    'MT',
    'MS',
    'MG',
    'PA',
    'PB',
    'PR',
    'PE',
    'PI',
    'RJ',
    'RN',
    'RS',
    'RO',
    'RR',
    'SC',
    'SP',
    'SE',
    'TO',
  ];
  return validStates.includes(cleanState);
};

/**
 * Validates if an address number is valid (numeric or "S/N")
 * @param number - Address number
 * @returns true if valid, false otherwise
 */
export const isValidAddressNumber = (number: string): boolean => {
  const trimmed = number.trim();
  const isNumeric = /^\d+$/.test(trimmed);
  const isSN = /^s\/n$/i.test(trimmed);
  return isNumeric || isSN;
};
